"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ButtonModule = _interopRequireDefault(require("./Button.module.scss"));

var _FBUIConstants = require("../../../../utils/FBUIConstants");

var _excluded = ["onClick", "children", "size", "variant", "fullWidth", "className", "forwardedRef", "type"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * # Button
 * Simple Foodbomb Button Component
 *
 * ## Modifiers
 * ### Variants
 * ```
 * ['primary', 'seconday', 'danger', 'success', 'light_primary']
 * ```
 *
 * ### Sizes
 * ```
 * ['regular', 'large', 'small', 'extra_small']
 * ```
 *
 * ## PropTypes:
 * ```js
 *  FBButton.propTypes = {
 *    onClick: PropTypes.func,
 *    children: PropTypes.node.isRequired,
 *    size: PropTypes.oneOf(Object.values(BUTTON_SIZES)),
 *    variant: PropTypes.oneOf(Object.values(BUTTON_VARIANTS)),
 *    fullWidth: PropTypes.bool,
 *    className: PropTypes.string,
 *    forwardedRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.instanceOf(Element) })]),
 *  };
 * ```
 *
 * ## Example
 * ```js
 * <Button
 *   variant="priamry"
 *   onClick={handleClick}
 *   fullWidth
 * >Sign In</Button>
 * ```
 */
var FBButton = function FBButton(_ref) {
  var onClick = _ref.onClick,
      children = _ref.children,
      size = _ref.size,
      variant = _ref.variant,
      fullWidth = _ref.fullWidth,
      className = _ref.className,
      forwardedRef = _ref.forwardedRef,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      props = _objectWithoutProperties(_ref, _excluded);

  var buttonStyles = [_ButtonModule.default.FBButton];

  if (size) {
    buttonStyles.push(_ButtonModule.default[size]);
  }

  if (variant) {
    buttonStyles.push(_ButtonModule.default[variant]);
  }

  if (fullWidth) {
    buttonStyles.push(_ButtonModule.default.fullWidth);
  }

  buttonStyles.push(className);
  return /*#__PURE__*/_react.default.createElement(_core.Button, _extends({
    fullWidth: fullWidth,
    onClick: onClick,
    ref: forwardedRef,
    className: buttonStyles.join(' '),
    type: type,
    disableRipple: true
  }, props), children);
};

FBButton.propTypes = {
  onClick: _propTypes.default.func,
  children: _propTypes.default.node.isRequired,
  size: _propTypes.default.oneOf(Object.values(_FBUIConstants.BUTTON_SIZES)),
  variant: _propTypes.default.oneOf(Object.values(_FBUIConstants.BUTTON_VARIANTS)),
  fullWidth: _propTypes.default.bool,
  className: _propTypes.default.string,
  type: _propTypes.default.string,
  forwardedRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.instanceOf(Element)
  })])
};

var _default = _react.default.forwardRef(function (props, ref) {
  return /*#__PURE__*/_react.default.createElement(FBButton, _extends({}, props, {
    forwardedRef: ref
  }));
});

exports.default = _default;

//# sourceMappingURL=Button.js.map